import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6373e38e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "titlePages" }, " Estado DB ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Cambium Data", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Eventos", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Latencia", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "LTE Data", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Predicciones", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Rajant Data", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Sensores", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Servidor Data", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitleDashboard" }, "Ubicación GPS", -1))

import { onMounted, ref, Ref } from 'vue'
import axios        from 'axios'

// COMPONENTS
import CONSTAPIS    from '@/constants/apis';
import { TIMEOUTTIME } from '@/constants/apis';

// INTERFACES
import { DBSTATUS } from '@/interfaces/SmartLink/Admin'
import { showConsoleError } from '@/functions/errors'
import { TOKEN } from '@/constants/labels';


export default /*#__PURE__*/_defineComponent({
  __name: 'DBstatusview',
  setup(__props) {

const databaseInfo:Ref<DBSTATUS> = ref({})
        
onMounted(async() => {
    /**
     * Captura los valores de la API: 'getDataBaseStatus'
     */
    await axios.get(CONSTAPIS.APIS.value.general.getDBStatus, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((res)=>{
        databaseInfo.value = res.data[0];
    })
    .catch(function (error) {
        showConsoleError(error);
    });
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "defaultCard",
    color: "bgtopology"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (databaseInfo.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "ma-0 mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.cambium_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.cambium_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.eventos === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.eventos === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.latencia === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.latencia === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value?.LTE_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.LTE_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.predicciones === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.predicciones === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.rajant_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.rajant_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.sensores === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.sensores === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.servidor_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.servidor_data === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3",
                lg: "2",
                xl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "bgDashCard",
                    class: "dbCard pt-7 text-center",
                    height: "170"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "70",
                        icon: databaseInfo.value.ubicacion_gps === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline',
                        color: databaseInfo.value.ubicacion_gps === 1 ? 'green' : 'red'
                      }, null, 8, ["icon", "color"]),
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})